export { FeaturedIcons } from './FeaturedIcons';
export { Hero } from './Hero';
export { ImageCTA } from './ImageCTA';
export { Logos } from './Logos';
export { VideoHero } from './VideoHero';
export { Testimonial } from './Testimonial';
export { ColumnFeatures } from './ColumnFeatures';
export { Newsroom } from './Newsroom';
export { Form } from './Form';
